/* eslint-disable */
/**
 * @fileoverview Quick Stats Component
 *
 * Displays statistical cards showing key metrics like hours, revenue, etc.
 * Currently not actively used in the dashboard but prepared for future use.
 *
 * @author Clockwise CPA Development Team
 * @version 1.0.0
 */

import React, { memo } from 'react';
import {
    FiClock,
    FiDollarSign,
    FiUsers,
    FiFileText,
    FiCheckCircle,
    FiTrendingUp
} from 'react-icons/fi';

/**
 * QuickStats Component
 *
 * @param {Object} props
 * @param {Object} props.stats - Statistics object
 * @param {Object} props.permissions - User permissions
 * @returns {JSX.Element|null}
 */
const QuickStats = memo(({ stats, permissions }) => {
    // Only show stats if user has relevant permissions
    if (!permissions.canViewTimeEntries && !permissions.canViewClients && !permissions.canViewInvoices) {
        return null;
    }

    const statCards = [
        {
            label: "Today's Hours",
            value: stats.todayHours,
            icon: <FiClock />,
            color: 'primary',
            show: permissions.canViewTimeEntries
        },
        {
            label: 'Week Hours',
            value: stats.weekHours,
            icon: <FiTrendingUp />,
            color: 'success',
            show: permissions.canViewTimeEntries
        },
        {
            label: 'Active Clients',
            value: stats.activeClients,
            icon: <FiUsers />,
            color: 'info',
            show: permissions.canViewClients
        },
        {
            label: 'Pending Invoices',
            value: stats.pendingInvoices,
            icon: <FiFileText />,
            color: 'warning',
            show: permissions.canViewInvoices
        },
        {
            label: 'Month Revenue',
            value: `$${stats.monthRevenue?.toLocaleString() || 0}`,
            icon: <FiDollarSign />,
            color: 'success',
            show: permissions.canViewBilling
        },
        {
            label: 'Completed Tasks',
            value: stats.completedTasks,
            icon: <FiCheckCircle />,
            color: 'primary',
            show: permissions.canViewTimeEntries
        }
    ].filter(stat => stat.show);

    if (statCards.length === 0) {
        return null;
    }

    return (
        <section className="db-metrics-section">
            <h2 className="d-section-title">Quick Stats</h2>
            <div className="db-metrics-grid">
                {statCards.map((stat, index) => (
                    <div className="db-metric-card" key={index}>
                        <div className={`db-metric-icon bg-${stat.color}`}>
                            {stat.icon}
                        </div>
                        <div className="db-metric-content">
                            <p className="db-metric-value">{stat.value}</p>
                            <p className="db-metric-label">{stat.label}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
});

QuickStats.displayName = 'QuickStats';

export default QuickStats;
